






  



  

  

  


let validations = {"user_email":[{"validator":"presence","options":{"if":"email_required?"},"error_messages":{"blank":"Campo obligatorio."}},{"validator":"uniqueness","options":{"allow_blank":true,"case_sensitive":true,"if":"devise_will_save_change_to_email?"},"error_messages":{"taken":"Este correo electrónico ya ha sido registrado."}},{"validator":"format","options":{"with":"(?-mix:\\A[^@\\s]+@[^@\\s]+\\z)","allow_blank":true,"if":"devise_will_save_change_to_email?"},"error_messages":{"invalid":"Este correo electrónico no es válido. Asegúrate de ingresar el correcto."}},{"validator":"presence","options":{},"error_messages":{"blank":"Campo obligatorio."}}],"user_first_name":[{"validator":"presence","options":{},"error_messages":{"blank":"Campo obligatorio."}}],"user_paternal_surname":[{"validator":"presence","options":{},"error_messages":{"blank":"Campo obligatorio."}}],"user_rating":[{"validator":"presence","options":{},"error_messages":{"blank":"Campo obligatorio."}},{"validator":"format","options":{"with":"(?-mix:\\d+)","message":"bad_number"},"error_messages":{"invalid":"Debe ser un número"}}],"user_trips":[{"validator":"presence","options":{},"error_messages":{"blank":"Campo obligatorio."}},{"validator":"format","options":{"with":"(?-mix:\\d+)","message":"bad_number"},"error_messages":{"invalid":"Debe ser un número"}}],"user_company":[{"validator":"presence","options":{},"error_messages":{"blank":"Campo obligatorio."}}],"user_state":[{"validator":"presence","options":{},"error_messages":{"blank":"Campo obligatorio."}}],"user_mobile_phone":[{"validator":"presence","options":{},"error_messages":{"blank":"Campo obligatorio."}},{"validator":"length","options":{"is":10},"error_messages":{"wrong_length":{"one":"Debe ser 1 carácter de longitud","other":"Debe ser %{count} caracteres de longitud"}}},{"validator":"format","options":{"with":"(?-mix:\\A\\d+\\Z)"},"error_messages":{"invalid":"Este número celular no es válido. Asegúrate de ingresar uno correcto."}},{"validator":"uniqueness","options":{},"error_messages":{"taken":"Este número de celular ya ha sido registrado."}}],"user_password":[{"validator":"presence","options":{"if":"password_required?"},"error_messages":{"blank":"Campo obligatorio."}},{"validator":"confirmation","options":{"case_sensitive":true,"if":"password_required?"},"error_messages":{"confirmation":"no coincide"}},{"validator":"length","options":{"allow_blank":true,"minimum":6,"maximum":128},"error_messages":{"wrong_length":{"one":"longitud errónea (debe ser de %{count} carácter)","other":"longitud errónea (debe ser de %{count} caracteres)"}}}],"user_income":[{"validator":"format","options":{"with":"(?-mix:\\d+)","message":"bad_number"},"error_messages":{"invalid":"Debe ser un número"}}],"issue_user_email":[{"validator":"presence","options":{},"error_messages":{"blank":"Campo obligatorio."}},{"validator":"format","options":{"allow_blank":true,"with":"(?-mix:\\A[^@\\s]+@[^@\\s]+\\z)"},"error_messages":{"invalid":"Este correo electrónico no es válido. Asegúrate de ingresar el correcto."}},{"validator":"uniqueness","options":{"model":"user"},"error_messages":{"taken":"Este correo electrónico ya ha sido registrado."}}],"issue_user_mobile_phone":[{"validator":"presence","options":{},"error_messages":{"blank":"Campo obligatorio."}},{"validator":"uniqueness","options":{"model":"user"},"error_messages":{"taken":"Este número de celular ya ha sido registrado."}},{"validator":"length","options":{"allow_blank":true,"is":10},"error_messages":{"wrong_length":{"one":"Debe ser 1 carácter de longitud","other":"Debe ser %{count} caracteres de longitud"}}},{"validator":"format","options":{"allow_blank":true,"with":"(?-mix:\\A\\d+\\Z)"},"error_messages":{"invalid":"Este número celular no es válido. Asegúrate de ingresar uno correcto."}}],"issue_contact_full_name":[{"validator":"presence","options":{},"error_messages":{"blank":"Campo obligatorio."}}],"issue_contact_mobile_phone":[{"validator":"presence","options":{},"error_messages":{"blank":"Campo obligatorio."}},{"validator":"length","options":{"allow_blank":true,"is":10},"error_messages":{"wrong_length":{"one":"Debe ser 1 carácter de longitud","other":"Debe ser %{count} caracteres de longitud"}}},{"validator":"format","options":{"allow_blank":true,"with":"(?-mix:\\A\\d+\\Z)"},"error_messages":{"invalid":"Este número celular no es válido. Asegúrate de ingresar uno correcto."}}],"issue_contact_relationship":[{"validator":"presence","options":{},"error_messages":{"blank":"Campo obligatorio."}}],"issue_guarantor_first_name":[{"validator":"presence","options":{},"error_messages":{"blank":"Campo obligatorio."}}],"issue_guarantor_middle_name":[{"validator":"presence","options":{},"error_messages":{"blank":"Campo obligatorio."}}],"issue_guarantor_paternal_surname":[{"validator":"presence","options":{},"error_messages":{"blank":"Campo obligatorio."}}],"issue_guarantor_maternal_surname":[{"validator":"presence","options":{},"error_messages":{"blank":"Campo obligatorio."}}],"issue_guarantor_mobile_phone":[{"validator":"presence","options":{},"error_messages":{"blank":"Campo obligatorio."}},{"validator":"length","options":{"allow_blank":true,"is":10},"error_messages":{"wrong_length":{"one":"Debe ser 1 carácter de longitud","other":"Debe ser %{count} caracteres de longitud"}}},{"validator":"format","options":{"allow_blank":true,"with":"(?-mix:\\A\\d+\\Z)"},"error_messages":{"invalid":"Este número celular no es válido. Asegúrate de ingresar uno correcto."}}],"issue_guarantor_email":[{"validator":"presence","options":{},"error_messages":{"blank":"Campo obligatorio."}},{"validator":"format","options":{"allow_blank":true,"with":"(?-mix:\\A[^@\\s]+@[^@\\s]+\\z)"},"error_messages":{"invalid":"Este correo electrónico no es válido. Asegúrate de ingresar el correcto."}}]}
validations  = {
  ...validations,
  verifications_email: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
    {
      error_messages: {
        invalid: 'Este correo electrónico no es válido. Asegúrate de ingresar el correcto.'
      },
      options: {
        with: '(?-mix:\\A[^@\\s]+@[^@\\s]+\\z)'
      },
      validator: "format"
    }
  ],
  verifications_mobile_phone: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
    {
      error_messages: {
        wrong_length: {
          one: 'Debe ser 1 carácter de longitud',
          other: 'Debe ser %{count} caracteres de longitud'
        }
      },
      options: {
        is: 10
      },
      validator: "length"
    },
    {
      error_messages: {
        invalid: 'Este número celular no es válido. Asegúrate de ingresar uno correcto.'
      },
      options: {
        with: '(?-mix:\\A\\d+\\Z)'
      },
      validator: "format"
    }
  ],
  user_password: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    }
  ],
  verifications_password: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    }
  ],
  verifications_authorize: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    }
  ],
  user_rfc: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
    {
      error_messages: {
        wrong_length: {
          one: 'Debe ser 1 carácter de longitud',
          other: 'Debe ser %{count} caracteres de longitud'
        }
      },
      options: {
        is: 13
      },
      validator: "length"
    },
  ],
  user_curp: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
    {
      error_messages: {
        wrong_length: {
          one: 'Tu CURP está incompleto',
          other: 'El formato excede los %{count} dígitos'
        }
      },
      options: {
        minimum: 18,
        maximum: 18
      },
      validator: "length"
    },
  ],
  user_rfc_name_and_date: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
    {
      error_messages: {
        wrong_length: {
          one: 'Debe ser 1 carácter de longitud',
          other: 'Debe ser %{count} caracteres de longitud'
        }
      },
      options: {
        is: 10
      },
      validator: "length"
    },
  ],
  user_rfc_uniq_key: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
    {
      error_messages: {
        wrong_length: {
          one: 'Debe ser 1 carácter de longitud',
          other: 'Debe ser %{count} caracteres de longitud'
        }
      },
      options: {
        is: 3
      },
      validator: "length"
    },
  ],
  user_gender: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  user_civil_status: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  user_studies_level: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  user_number_children: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  user_live_in_location_since: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  user_product_attractiveness: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  user_own_resources: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  user_pep: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  user_personal_information_granted: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  user_uber_classification: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  user_sells_channel: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  loan_application_addresses_attributes_street: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  loan_application_addresses_attributes_external_number: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  loan_application_addresses_attributes_postal_code: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  loan_application_addresses_attributes_neighborhood: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  loan_application_addresses_attributes_lived_in_since: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  loan_application_addresses_attributes_housing_type: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  loan_application_addresses_attributes_city: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  loan_application_addresses_attributes_state: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  loan_application_addresses_attributes_phone: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
    {
      error_messages: {
        wrong_length: {
          one: 'Debe ser 1 carácter de longitud',
          other: 'Debe ser %{count} caracteres de longitud'
        }
      },
      options: {
        is: 10
      },
      validator: "length"
    },
    {
      error_messages: {
        invalid: 'Este número celular no es válido. Asegúrate de ingresar uno correcto.'
      },
      options: {
        with: '(?-mix:\\A\\d+\\Z)'
      },
      validator: "format"
    }
  ],
  application_contacts_attributes_0_full_name: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  application_contacts_attributes_0_mobile_phone: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  application_contacts_attributes_0_relationship: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  application_contacts_attributes_1_full_name: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  application_contacts_attributes_1_mobile_phone: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  application_contacts_attributes_1_relationship: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  loan_application_curp: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
    {
      error_messages: {
        wrong_length: {
          one: 'Tu CURP está incompleto',
          other: 'El formato excede los %{count} dígitos'
        }
      },
      options: {
        minimum: 18,
        maximum: 18
      },
      validator: "length"
    },
  ],
  loan_application_additional_incomes: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    }
  ],
  loan_application_cars: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    }
  ],
  leasing_product_id: [
    {
      error_messages: {
        blank: "Selecciona un auto",
      },
      options: {},
      validator: "presence"
    },
  ],
  user_application_attributes_addresses_attributes_street: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  user_application_attributes_addresses_attributes_external_number: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  user_application_attributes_addresses_attributes_postal_code: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  user_application_attributes_addresses_attributes_neighborhood: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  user_application_attributes_addresses_attributes_lived_in_since: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  user_application_attributes_addresses_attributes_housing_type: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  user_application_attributes_addresses_attributes_city: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  user_application_attributes_addresses_attributes_state: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  user_application_attributes_addresses_attributes_phone: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
    {
      error_messages: {
        wrong_length: {
          one: 'Debe ser 1 carácter de longitud',
          other: 'Debe ser %{count} caracteres de longitud'
        }
      },
      options: {
        is: 10
      },
      validator: "length"
    },
    {
      error_messages: {
        invalid: 'Este número celular no es válido. Asegúrate de ingresar uno correcto.'
      },
      options: {
        with: '(?-mix:\\A\\d+\\Z)'
      },
      validator: "format"
    }
  ],
  user_application_attributes_addresses_attributes_address_type: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  user_application_attributes_addresses_attributes_visibility: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  loan_application_contacts_attributes_0_full_name: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  loan_application_contacts_attributes_0_mobile_phone: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
    {
      error_messages: {
        wrong_length: {
          one: 'Debe ser 1 carácter de longitud',
          other: 'Debe ser %{count} caracteres de longitud'
        }
      },
      options: {
        is: 10
      },
      validator: "length"
    },
  ],
  loan_application_contacts_attributes_0_relationship: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  loan_application_contacts_attributes_1_full_name: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  loan_application_contacts_attributes_1_mobile_phone: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
    {
      error_messages: {
        wrong_length: {
          one: 'Debe ser 1 carácter de longitud',
          other: 'Debe ser %{count} caracteres de longitud'
        }
      },
      options: {
        is: 10
      },
      validator: "length"
    },
  ],
  loan_application_contacts_attributes_1_relationship: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  user_application_attributes_contacts_attributes_full_name: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  user_application_attributes_contacts_attributes_mobile_phone: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
    {
      error_messages: {
        wrong_length: {
          one: 'Debe ser 1 carácter de longitud',
          other: 'Debe ser %{count} caracteres de longitud'
        }
      },
      options: {
        is: 10
      },
      validator: "length"
    },
  ],
  user_application_attributes_contacts_attributes_relationship: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
  ],
  user_application_attributes_curp: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    },
    {
      error_messages: {
        wrong_length: {
          one: 'Tu CURP está incompleto',
          other: 'El formato excede los %{count} dígitos'
        }
      },
      options: {
        minimum: 18,
        maximum: 18
      },
      validator: "length"
    },
  ],
  user_application_attributes_additional_incomes: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    }
  ],
  user_application_attributes_cars: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"

    }
  ],
  user_application_attributes_emergency_contact_attributes_first_name: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    }
  ],
  user_application_attributes_emergency_contact_attributes_paternal_surname: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    }
  ],
  user_application_attributes_emergency_contact_attributes_relationship: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    }
  ],
  user_application_attributes_emergency_contact_attributes_mobile_phone: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
    {
      error_messages: {
        wrong_length: {
          one: 'Debe ser 1 carácter de longitud',
          other: 'Debe ser %{count} caracteres de longitud'
        }
      },
      options: {
        is: 10
      },
      validator: "length"
    },
    {
      error_messages: {
        invalid: 'Este número celular no es válido. Asegúrate de ingresar uno correcto.'
      },
      options: {
        with: '(?-mix:\\A\\d+\\Z)'
      },
      validator: "format"
    }
  ],
  user_application_attributes_emergency_contact_attributes_email: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
    {
      error_messages: {
        invalid: 'Este correo electrónico no es válido. Asegúrate de ingresar el correcto.'
      },
      options: {
        with: '(?-mix:\\A[^@\\s]+@[^@\\s]+\\z)'
      },
      validator: "format"
    }
  ],
  user_application_attributes_emergency_contact_attributes_street: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  user_application_attributes_emergency_contact_attributes_external_number: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  user_application_attributes_emergency_contact_attributes_postal_code: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  user_application_attributes_emergency_contact_attributes_neighborhood: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  user_application_attributes_emergency_contact_attributes_city: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  user_application_attributes_emergency_contact_attributes_state: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  early_termination_info_outstanding_amount: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  early_termination_info_cancellation_reason: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  early_termination_info_contract_date: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  early_termination_info_asset_brand: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  early_termination_info_asset_type: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  early_termination_info_asset_model: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  early_termination_info_interior_color: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  early_termination_info_exterior_color: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  early_termination_info_license_plates: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  early_termination_info_license_plates_state: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  early_termination_info_serial_number: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  early_termination_info_engine_number: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  early_termination_info_invoice_number: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  early_termination_info_comment: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  early_termination_info_contract_legal_representative: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  early_termination_info_cancellation_legal_representative: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  forced_early_termination_info_paid_amount: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  forced_early_termination_info_overdue_rents_amount: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  forced_early_termination_info_other_debts_amount: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  forced_early_termination_info_advance_rents_balance: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  forced_early_termination_info_payment_plan: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  forced_early_termination_info_guarantee_use: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  forced_early_termination_info_rents_with_plan_amount: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  forced_early_termination_info_rents_paid_plan_amount: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  forced_early_termination_info_contract_start_date: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  forced_early_termination_info_contract_end_date: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  forced_early_termination_info_rents_plan: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  forced_early_termination_info_branch_office_name: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  forced_early_termination_info_rents_paid: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  forced_early_termination_info_vehicle: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  forced_early_termination_info_weekly_payment_amount: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  forced_early_termination_info_advance_rents_amount: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  forced_early_termination_info_vin: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ],
  forced_early_termination_info_credierp_reference: [
    {
      error_messages: {
        blank: "Campo obligatorio",
      },
      options: {},
      validator: "presence"
    },
  ]
}
export default validations;
